export default "__VITE_ASSET__fFnPxVbj__"